<template lang="html">
  <div>
		<div class="panel panel-default">
			<div class="panel-heading">
			    <div>
			        <span>
			            My Clients
			        </span>
			    </div>
			</div>
			<div class="panel-body">
			    <table class="table clients">
			        <thead>
			            <tr>
			                <th>Name</th>
			                <th>Assigned</th>
			            </tr>
			        </thead>

			        <tbody>
			            <tr v-for="client in clients">
			                <td>
			                    <a :href="`/admin#/clients/${client.slug}`">{{ client.name }}</a>
			                </td>
                            <td class="manage">
                                <button class="btn btn-primary" v-if="currentlyAssigned(client)" @click="dissociateClient(client)">
                                    <span class="fa fa-check"></span>
                                </button>
                                <button class="btn btn-default-outline" v-else @click="assignClient(client)">
                                    <span class="fa fa-plus"></span>
                                </button>
                            </td>
			            </tr>
			        </tbody>
			    </table>
			</div>
		</div>
  </div>
</template>

<script>

export default {
    props: ['user'],

    data() {
        return {
            clients: []
        }
    },

    mounted() {
        this.getUserClients();
    },

    methods: {
        getUserClients() {
            axios.get('/api/clients')
                .then(({data}) => this.clients = data)
                .catch(({data}) => console.log(data));
        },

        currentlyAssigned(client) {
            return client.team_members.filter(member => member.id === this.user.id).length > 0;
        },

        assignClient(client) {
            axios.put(`/api/user/clients/${client.slug}`)
                .then(() => client.team_members.push(this.user))
                .catch(({data}) => console.log(data));
        },

        dissociateClient(client) {
            axios.delete(`/api/user/clients/${client.slug}`)
                .then(() => {
                    client.team_members = client.team_members.filter(member => member.id !== this.user.id);
                })
                .catch(({data}) => console.log(data));
        }
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/user/UserClients.vue